import * as styles from './shared/styles';
import * as global from './shared/global';
import * as animation from './shared/animation';
import * as icons from './shared/icons';
import * as site from './shared/site';

export { styles, global, animation, icons, site };

export { default as Icon } from './Icon';
export { default as Link } from './Link';

export { default as WithTooltip } from './tooltip/WithTooltip';
export { default as TooltipMessage } from './tooltip/TooltipMessage';
export { default as TooltipNote } from './tooltip/TooltipNote';
export { default as TooltipLinkList } from './tooltip/TooltipLinkList';

// export { default as Modal } from './modal/Modal';



// WEBPACK FOOTER //
// ./src/new-components/basics/index.js